import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { RestService } from '../services/rest.service';
import { RestaurantModel } from './add-restaurant/RestaurantModel';


@Injectable({
  providedIn: 'root'
})
export class RestaurantServiceService {

  constructor(
    private restHttp: RestService
  ) { }


  getAllRestaurants(cityId, PageNO: number, PageSize: number): Observable<any> {
    // tslint:disable-next-line:max-line-length
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/AllRestaurant?cityId=${cityId}&pageNumber=${PageNO}&pageSize=${PageSize}`);
  }
  getAllRestaurantsType( ): Observable<any> {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/RestaurantType`);
  }
  getAllMealCategory( ): Observable<any> {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/MealCategory`);
  }
  public DeleteResturant(id) {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/DeleteRestaurent?restroId=${id}`);
  }
  public DeleteResturantType(id) {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/DeleteRestaurantType?id=${id}`);
  }
  public DeleteMealCategory(id) {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/DeleteMealCategorys?mealCategoryId=${id}`);
  }
  public DeleteScaleUnit(id) {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/DeleteUnits?unitId=${id}`);
  }
  public DeleteIngrdientType(id) {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/DeleteIngredientType?id=${id}`);
  }
  getPagedRestaurants(): Observable<any> {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/Restaurant`);
  }

  public getAllCountries(): Observable<any> {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/Country`);
  }

  public getCitWithId(id) {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/CityById?countryId=${id}`);
  }
  public getCitWithCItyId(id) {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/CityById/${id}`);
  }
  public getScaleId(id) {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/Scale?id=${id}`);
  }
  public getAddonId(id) {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/AddOn?id=${id}`);
  }
  public getIngredientwithId(id) {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/Ingredients?id=${id}`);
  }
  public CreateResturant(model: RestaurantModel) {
    return this.restHttp.requestAllowAnonymousPOST(`${this.restHttp.serverURL}/Restaurant`, model);
  }
  public CreateResturantType(model: any) {
    return this.restHttp.requestAllowAnonymousPOST(`${this.restHttp.serverURL}/RestaurantType`, model);
  }
  public CreateMealCategory(model: any) {
    return this.restHttp.requestAllowAnonymousPOST(`${this.restHttp.serverURL}/MealCategory`, model);
  }

  getRestaurantbyId(id): Observable<any> {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/Restaurant/${id}`);
  }
  getRestaurantTypebyId(id): Observable<any> {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/RestaurantType/${id}`);
  }
  getMealCategorybyId(id): Observable<any> {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/MealCategory/${id}`);
  }

  public GETAllOrders(id): Observable<any> {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/AllOrders?restaurantId=${id}`);
  }
  public GETAllFeedBack(id): Observable<any> {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/AllRestaurantReviews?restaurantId=${id}`);
  }

  MediaUpload(formData) {
    return this.restHttp.requestPOSTX(`${this.restHttp.serverURL}/RestaurantLogo/MediaUpload`, formData);
   }
   MealImageUpload(formData) {
    return this.restHttp.requestPOSTX(`${this.restHttp.serverURL}/MealImage`, formData);
   }
   uploadMealCategory(formData) {
    return this.restHttp.requestPOSTX(`${this.restHttp.serverURL}/MealCategoryImage`, formData);
   }
   RestaurantImageUpload(formData) {
    return this.restHttp.requestPOSTX(`${this.restHttp.serverURL}/RestaurantImage/MediaUpload`, formData);
   }
   public UpdateResturant(model: RestaurantModel) {
    return this.restHttp.requestAllowAnonymousPOST(`${this.restHttp.serverURL}/UpdateRestaurant`, model);
  }
  public UpdateResturantType(model: RestaurantModel) {
    return this.restHttp.requestAllowAnonymousPOST(`${this.restHttp.serverURL}/UpdateRestaurantType`, model);
  }
  public UpdateMealCategory(model: RestaurantModel) {
    return this.restHttp.requestAllowAnonymousPOST(`${this.restHttp.serverURL}/UpdateMealCategorys`, model);
  }
  MediaUploadofRestaurant(formData) {
    return this.restHttp.requestPOSTX(`${this.restHttp.serverURL}/RestaurantImg/MediaUpload`, formData);
  }
  getRestautrantImgbyId(id): Observable<any> {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/RestaurantImg/${id}`);
  }

  public DeleteImage(id) {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/DeleteRestaurantImage?imageId=${id}`);
  }
  // Menu
  public DeleteMenu(id) {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/DeleteMealMainType?mealMenuId=${id}`);
  }
  getRestaurantMenuById(id): Observable<any> {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/RestaurantMenu?restaurantId=${id}`);
  }
  setRestaurantMenu(data) {
    return this.restHttp.requestPOSTX(`${this.restHttp.serverURL}/RestaurantMenu`, data);
  }
  getMenubyId(id): Observable<any> {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/MealMainType/${id}`);
  }
  public UpdateMenu(model: any) {
    return this.restHttp.requestAllowAnonymousPOST(`${this.restHttp.serverURL}/UpdateMealManu`, model);
  }
  public DeleteMeal(id) {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/DeleteMeal?mealId=${id}`);
  }
  public GETIsFeatuedStatus(id): Observable<any> {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/IsFeaturedMeal?mealId=${id}`);
  }
  getMealbyId(id): Observable<any> {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/MealById?mealId=${id}`);
  }
  public GETMealCategories(): Observable<any> {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/GetAllMealCategories`);
  }
  public UpdateMeal(model: any) {
    return this.restHttp.requestAllowAnonymousPOST(`${this.restHttp.serverURL}/UpdateMeals`, model);
  }
  public GETCustomMeal(id): Observable<any> {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/CustomMeal?mealId=${id}`);
  }
  public GETMealScale(id): Observable<any> {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/GetAllScalesByMealId?mealId=${id}`);
  }
  public GETMealIngredient(id): Observable<any> {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/GetAllIngredientsByMealId?mealId=${id}`);
  }
  public GETMealAddon(id): Observable<any> {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/GetAllAddOnsByMealId?mealId=${id}`);
  }
  public CreateAddOn(model: any) {
    return this.restHttp.requestAllowAnonymousPOST(`${this.restHttp.serverURL}/AddOn`, model);
  }
  public DeleteAddon(id) {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/DeleteAddOns?addOnId=${id}`);
  }
  public DeleteIngredient(id) {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/DeleteIngredient?ingredientId=${id}`);
  }
  public DeleteScale(id) {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/DeleteScale?scaleId=${id}`);
  }
  public UpdateIngrediant(model) {
    return this.restHttp.requestAllowAnonymousPOST(`${this.restHttp.serverURL}/UpdateIngredient`, model);
  }
  public UpdateAddon(model) {
    return this.restHttp.requestAllowAnonymousPOST(`${this.restHttp.serverURL}/UpdateAddOns`, model);
  }
  public UpdateScale(model) {
    return this.restHttp.requestAllowAnonymousPOST(`${this.restHttp.serverURL}/UpdateScale`, model);
  }
  public CreateIngrediants(model) {
    return this.restHttp.requestAllowAnonymousPOST(`${this.restHttp.serverURL}/Ingredients`, model);
  }
  public CreateScale(model) {
    return this.restHttp.requestAllowAnonymousPOST(`${this.restHttp.serverURL}/Scale`, model);
  }
  public CreateScaleUnit(model) {
    return this.restHttp.requestAllowAnonymousPOST(`${this.restHttp.serverURL}/Unit`, model);
  }
  public CreateIngredientType(model) {
    return this.restHttp.requestAllowAnonymousPOST(`${this.restHttp.serverURL}/IngredientsType`, model);
  }
  getAllUnitByScaleId( id: any): Observable<any> {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/Unit?scaleId=${id}`);
  }
  getAllTypeByIngrdiantId( id: any): Observable<any> {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/IngredientsType?ingredeitId=${id}`);
  }
  getIngredientTypeById( id: any): Observable<any> {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/IngredientsType?id=${id}`);
  }
  getScaleUnitById( id: any): Observable<any> {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/Unit?id=${id}`);
  }
  public UpdateIngredientType(model) {
    return this.restHttp.requestAllowAnonymousPOST(`${this.restHttp.serverURL}/UpdateIngredientType`, model);
  }
  public UpdateScaleUnit(model) {
    return this.restHttp.requestAllowAnonymousPOST(`${this.restHttp.serverURL}/UpdateUnits`, model);
  }
}
